import React from 'react';
import { useIntl } from 'react-intl';
import { DatedEvidence, EmptyComponent, Evidence } from '@eas/common-web';
import { Holiday } from '@models';
import { EvidenceApiUrl, Permission } from '@enums';
import { useEvidencePermission } from '@utils';
import { useColumns } from './holiday-columns';
import { Fields } from './holiday-fields';
import { useValidationSchema } from './holiday-schema';

export function Holidays() {
  const intl = useIntl();
  const validationSchema = useValidationSchema();
  const columns = useColumns();

  const btnPermissions = useEvidencePermission({
    options: {
      NEW: [Permission.HOLIDAY_WRITE],
      EDIT: [Permission.HOLIDAY_WRITE],
      REMOVE: [Permission.HOLIDAY_WRITE],
    },
  });

  const evidence = DatedEvidence.useDatedEvidence<Holiday>({
    identifier: 'HOLIDAY',
    apiProps: {
      url: EvidenceApiUrl.HOLIDAYS,
    },
    tableProps: {
      columns,
      tableName: intl.formatMessage({
        id: 'ZSD__HOLIDAYS__TABLE__TITLE',
        defaultMessage: 'Sviatky',
      }),
      showBulkActionButton: false,
      showReportButton: false,
      defaultSorts: [],
    },
    detailProps: {
      toolbarProps: {
        title: intl.formatMessage({
          id: 'ZSD__HOLIDAYS__DETAIL__TITLE',
          defaultMessage: 'Sviatok',
        }),
        subtitle: (holiday) => holiday?.name ?? '',
        showBtn: btnPermissions,
      },
      GeneralFieldsComponent: EmptyComponent,
      FieldsComponent: Fields,
      validationSchema,
    },
  });

  return <Evidence {...evidence} />;
}
